import { ConsoleSqlOutlined } from "@ant-design/icons";
import { axiosDelete, axiosGet, axiosPost, axiosPut } from "./ajaxServices";
import { urlCreateImage, urlDeleteImage, urlGetImageList, urlUpdateImage, urlUpdateImagePosition } from "./CONSTANTS";

export function apiCreateImage(data) {
  const url = urlCreateImage;
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  var formData = new FormData();
  formData.append("name", data.name);
  formData.append("status", data.status);

  // Handle multiple images - append each file with the same field name
  // Backend should handle this as an array (e.g., image_name[] or multiple image_name fields)
  if (data.image_name) {
    if (Array.isArray(data.image_name)) {
      data.image_name.forEach((file) => {
        if (file instanceof File) {
          formData.append("image_name[]", file); // Try array notation first
          // If backend doesn't support [], it might need just "image_name" repeated
        }
      });
    } else if (data.image_name instanceof File) {
      formData.append("image_name", data.image_name);
    }
  }
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
    .then(function (response) {
      resolve(response);
    })
    .catch((err) => {
      reject(err);
    });
  });
}

export function apiUpdateImage(data) {
  const url = urlUpdateImage;
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  var formData = new FormData();
  formData.append("id", data.id);
  formData.append("name", data.name);
  formData.append("status", data.status);
  
  // Send updated thumbnail_image (includes existing images after removals)
  // Always send so backend knows current state - send "[]" when empty so old images are not re-used
  if (data.thumbnail_image !== undefined) {
    if (Array.isArray(data.thumbnail_image)) {
      formData.append("thumbnail_image", JSON.stringify(data.thumbnail_image));
    } else if (data.thumbnail_image && data.thumbnail_image !== "") {
      formData.append("thumbnail_image", data.thumbnail_image);
    } else {
      // Empty string or falsy = user removed all existing images
      formData.append("thumbnail_image", "[]");
    }
  }
  
  // Handle multiple images - append each file with the same field name
  // Backend should handle this as an array (e.g., image_name[] or multiple image_name fields)
  if (data.image_name) {
    if (Array.isArray(data.image_name)) {
      data.image_name.forEach((file) => {
        if (file instanceof File) {
          formData.append("image_name[]", file); // Try array notation first
          // If backend doesn't support [], it might need just "image_name" repeated
        }
      });
    } else if (data.image_name instanceof File) {
      formData.append("image_name", data.image_name);
    }
  }
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
    .then(function (response) {
      resolve(response);
    })
    .catch((err) => {
      reject(err);
    });
  });
}

export function apiUpdateImagePosition(dataList) {
  const url = urlUpdateImagePosition;
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  var idList = []
  for (let i = 0; i<dataList.length; i++) {
    idList.push({id : dataList[i]['id']})
  }
  var formData = new FormData();
  formData.append("dataList", JSON.stringify(idList));
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
    .then(function (response) {
      resolve(response);
    })
    .catch((err) => {
      reject(err);
    });
  });
}

export const apiGetImageList = (currentPage, pageSize, startDate, endDate) => {
  const url = urlGetImageList;
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  var formData = new FormData();
  formData.append("currentPage", currentPage);
  formData.append("pageSize", pageSize);
  formData.append("startDate", startDate);
  formData.append("endDate", endDate);

  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


export function apiDeleteImage(id) {
  const url = urlDeleteImage;
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  var formData = new FormData();
  formData.append("id", id);
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
    .then(function (response) {
      resolve(response);
    })
    .catch((err) => {
      reject(err);
    });
  });
}
